import { z } from 'zod';
import type { BlockDefinition } from '../types';

// Marker "block" for the Bastion tenant. It carries ONLY the CMS-editable
// marketing-text map ({ token: string }); the actual page is the verbatim
// thebastion.io template, rendered by apps/web (see src/bastion.ts) which
// intercepts this marker before the normal React block pipeline. There is no
// visual renderer here on purpose — it exists so the text map is a valid,
// schema-checked page block that the admin editor can save/publish.
// Keys are template token names ([a-zA-Z0-9_]) and values are bounded strings —
// so an unexpected key or an oversized payload cannot reach a template slot. The
// value is additionally allowlist-sanitised at render time (apps/web bastion.ts). (H6)
export const bastionTemplateSchema = z.object({
  text: z.record(z.string().regex(/^[a-zA-Z0-9_]+$/), z.string().max(20000)).default({}),
});

type BastionTemplateProps = z.infer<typeof bastionTemplateSchema>;

// Never rendered on the marketing site (the web server handles Bastion pages
// directly). Returns null so it's inert if it ever reaches renderBlocks.
function Renderer(_props: BastionTemplateProps): null {
  return null;
}

export const bastionTemplateBlock: BlockDefinition<BastionTemplateProps> = {
  type: 'bastionTemplate',
  schema: bastionTemplateSchema,
  Renderer,
};
